import React from 'react'
import CampaignNameModal from '../../../Components/CampaignNameModal'
import WidgetNameModal from './WidgetNameModal'
import UltimateInstallModal from '../../Create/UltimateInstallModal'
import TitleShoppingButtonModal from './TitleShoppingButtonModal'
import ShareModal from '../../Create/ShareModal'
import MobilePreview from '../../../Components/MobilePreview'
import HelpModal from './HelpModal'

const Modals = ({
  showCampaignNameModal,
  setShowCampaignNameModal,
  showWidgetNameModal,
  setShowWidgetNameModal,
  showUltimateInstallModal,
  setShowUltimateInstallModal,
  showMobilePreview,
  setShowMobilePreview,
  showHelpModal,
  setShowHelpModal,
  values,
  selectedVideos,
  videos,
  setFieldValue,
  activeWidget,
  modalOpenType,
  setModalOpenType,
  submit,
  showShareModal,
  setShowShareModal
}) => {
  return (
    <>
      <CampaignNameModal isOpen={showCampaignNameModal} onClose={() => setShowCampaignNameModal(false)} values={values} />
      <WidgetNameModal isOpen={showWidgetNameModal} setIsOpen={setShowWidgetNameModal} />
      <UltimateInstallModal
        submit={submit}
        selectedVideos={selectedVideos}
        showUltimateInstallModal={showUltimateInstallModal}
        setShowUltimateInstallModal={setShowUltimateInstallModal}
        videos={videos}
        setFieldValue={setFieldValue}
        values={values}
        activeWidget={activeWidget}
      />
      <ShareModal campaignId={values.id} show={showShareModal} setShow={setShowShareModal} />

      <TitleShoppingButtonModal
        values={values}
        selectedVideos={selectedVideos}
        modalOpenType={modalOpenType}
        setModalOpenType={setModalOpenType}
      />

      {showMobilePreview && <MobilePreview campaign={values} videos={selectedVideos} close={() => setShowMobilePreview(false)} />}

      <HelpModal isOpen={showHelpModal} onClose={() => setShowHelpModal(false)} />
    </>
  )
}

export default Modals
